import { render, staticRenderFns } from "./msgEditMod.vue?vue&type=template&id=26f49c05&scoped=true&"
import script from "./msgEditMod.vue?vue&type=script&lang=js&"
export * from "./msgEditMod.vue?vue&type=script&lang=js&"
import style0 from "./msgEditMod.vue?vue&type=style&index=0&id=26f49c05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f49c05",
  null
  
)

export default component.exports